import { InjectionToken } from '@angular/core';

import { TradingAccount } from '../../../../domain/account.domain';
import { OrderSecurity } from '../../../../domain/security.domain';
import {
  OrderCapture,
  OrderItem,
  OrderRequest,
  OrderTerms,
  Strategy,
  TradingCredential
} from '../../domain';
import { OrderFormParameters, OrderEntryFormModel } from './order-entry.domain';

export interface BackendMapper<T> {
  getMapperType(): OrderSecurity;

  createOrderRequest(orderCaptureResponse: OrderCapture): OrderRequest<OrderTerms>;

  createCaptureRequest(
    form: T,
    selectedAccount: TradingAccount,
    tradingCredential: TradingCredential,
    strategy: Strategy
  ): OrderRequest;

  getItems(form: T): Array<OrderItem>;
}

export interface FormService<T> {
  initializeViewModel(selectedAccount?: TradingAccount, orderFormParameters?: OrderFormParameters): T;
}

export const ORDER_ENTRY_MAPPER = new InjectionToken<Array<BackendMapper<OrderEntryFormModel>>>('orderEntryMapper');

